(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-banner"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function updateCountdowns() {
      const timers = document.querySelectorAll('.announcement-countdown-timer-time');
      if (timers.length === 0) return;

      timers.forEach((timer) => {
        const wrapper = timer.closest('.announcement-countdown-timer');
        const endRaw = timer.dataset.endDatetime;

        if (!endRaw) {
          if (wrapper) wrapper.remove();
          return;
        }

        const end = new Date(endRaw).getTime();
        const now = Date.now();

        if (isNaN(end) || end <= now) {
          if (wrapper) wrapper.remove();
          return;
        }

        const diff = end - now;

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const mins = Math.floor((diff / (1000 * 60)) % 60);
        const secs = Math.floor((diff / 1000) % 60);

        const pad = (n) => String(n).padStart(2, '0');

        let output = '';

        if (days > 0) {
          output += `${pad(days)}D `;
        }

        output += `${pad(hours)}H ${pad(mins)}M ${pad(secs)}S`;

        timer.textContent = output.trim();
        timer.classList.remove('loading');
      });
    }

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builder_homepage-hero"] && !Shopify.designMode) return;
  try {
    
  const $reel = document.getElementById('js-homepage-reel');
  const $container = document.querySelector('.js-homepage-hero');
  const $firstBlock = document.querySelector('.builder-block');
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const reelWidth = $reel.offsetWidth;
  const containerHeight = $container.offsetHeight;
  const moveXValue = reelWidth - viewportWidth;
  const trigger = containerHeight - viewportHeight / 2;

  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.js-homepage-hero',
          start: 'top top',
          end: 'bottom bottom',
          scrub: true,
          invalidateOnRefresh: true,
        },
      })
      .to(
        '.js-homepage-reel',
        {
          x: -moveXValue,
          ease: 'power1.inOut',
        },
        0
      );
    gsap
      .timeline({
        scrollTrigger: {
          trigger: $firstBlock,
          start: 'top center',
          end: 'top top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      })
      .to(
        '.js-homepage-hero',
        {
          opacity: 0,
        },
        0
      );
  });

  document.addEventListener('scroll', function () {
    if (scrollY > trigger) {
      $navHeaderUpdateHero.classList.remove('transparent', 'inverted', 'hide-logo');
      $container.classList.add('disabled');
    } else {
      $navHeaderUpdateHero.classList.add('transparent', 'inverted', 'hide-logo');
      $container.classList.remove('disabled');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["builder_homepage-simple-hero"] && !Shopify.designMode) return;
  try {
    
  const $scrollButton = document.querySelector('.js-scroll-button');

  $scrollButton.addEventListener('click', function () {
    $navHeaderUpdateHero.classList.remove('transparent', 'inverted');
    gsap.to(window, {
      duration: 0.8,
      scrollTo: {
        y: window.innerHeight,
        autoKill: false,
        ease: 'power1.inOut',
      },
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    $('body').addClass('simple-hero');
    gsap
      .timeline({
        scrollTrigger: {
          trigger: '.js-homepage-simple',
          start: 'bottom bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      })
      .to(
        '.js-homepage-simple',
        {
          opacity: 0,
        },
        0
      );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page_studio-shapes"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const $shapeSelectors = document.querySelectorAll('.js-shape-selector');
    const $shapeGrids = document.querySelectorAll('.js-shape-grid');

    $shapeSelectors.forEach(function ($selector) {
      $selector.addEventListener('click', function (event) {
        $shapeSelectors.forEach(function ($element) {
          $element.classList.remove('is-active');
        });

        $shapeGrids.forEach(function ($grid) {
          $grid.classList.remove('is-active');
        });

        const dataName = event.currentTarget.getAttribute('data-name');

        event.currentTarget.classList.add('is-active');
        const $matchingGrid = document.getElementById(dataName);
        if ($matchingGrid) {
          $matchingGrid.classList.add('is-active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page_sunday-stay-in"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function getRandomReason() {
      return reasons[Math.floor(Math.random() * reasons.length)];
    }

    function changeHeight() {
      if ('.js-incoming') {
        var newHeight = $('.js-incoming').height();
        console.log(newHeight);
        $('.reason-reel').css('height', newHeight + 'px');
      } else {
        changeHeight();
      }
    }

    changeHeight();

    // document.querySelector('.js-reel-new').textContent = getRandomReason();

    document.querySelector('.js-reel-btn').addEventListener('click', function (event) {
      event.preventDefault();

      var btn = event.currentTarget;
      btn.classList.add('disabled');

      var incomingElem = document.querySelector('.js-incoming');
      var reelNewElem = document.querySelector('.js-reel-new');
      var reelInnerElem = document.querySelector('.js-reason-reel-inner');

      incomingElem.classList.add('animate-out');
      setTimeout(function () {
        incomingElem.remove();

        var newIncomingElem = document.createElement('div');
        newIncomingElem.classList.add('reason-reel-incoming', 'earlier-anim', 'js-incoming');

        var newHeadingElem = document.createElement('h1');
        newHeadingElem.classList.add('sunday', 'sunday-reason-text', 'display-two', 'no-margin', 'js-reel-new');
        newHeadingElem.textContent = getRandomReason();
        newIncomingElem.appendChild(newHeadingElem);

        reelInnerElem.before(newIncomingElem);
        changeHeight();
      }, 1000);

      reelInnerElem.classList.remove('animated');
      setTimeout(function () {
        reelInnerElem.classList.add('animated');
      }, 10);

      setTimeout(function () {
        btn.classList.remove('disabled');
      }, 5750);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
